module.exports = __webpack_public_path__ + "img/count_minus.4b50b550.svg";